<div class="row">
  <div class="col-lg-4 col-md-4 col-4 padding-right-2px timepicker ">
    <CodeTypeValue CodeType="CT100" class="timeinput">
    </CodeTypeValue>
  </div>
  <div class="col-lg-4 col-md-4 col-4 padding-left-2px timepicker">
    <CodeTypeValue CodeType="CT101" class="timeinput">
    </CodeTypeValue>
  </div>
  <div class="col-lg-3 col-md-3 col-3 padding-left-0px timepicker">
    <CodeTypeValue CodeType="CT102" class="timeinput">
    </CodeTypeValue>
  </div>
</div>
